export class SubmitTaskDialog {
  requestNbr: string;
  caseNbr: string;
  comments: string;
  header: string;
  type: string;
}



// WEBPACK FOOTER //
// ./src/models/submitTaskDialog.ts